<template>
  <div class="admin-dom-wrapper">
    <admin-nav active="dossiers" />

    <b-container fluid>
      <b-card>
        <h4 class="mb-2">
          Dossiers de domiciliation
        </h4>

        <b-row class="mb-2">
          <b-col md="3">
            <label>État</label>
            <b-form-select
              v-model="filters.etat"
              :options="optionsEtat"
              @change="loadList"
            />
          </b-col>
          <b-col md="3">
            <label>Traité</label>
            <b-form-select
              v-model="filters.traite"
              :options="optionsTraite"
              @change="loadList"
            />
          </b-col>
          <b-col md="3">
            <label>Archivé</label>
            <b-form-select
              v-model="filters.archive"
              :options="optionsArchive"
              @change="loadList"
            />
          </b-col>
          <b-col md="3">
            <label>Recherche</label>
            <b-form-input
              v-model="filters.q"
              placeholder="Nom, email, raison sociale"
              @input="onSearch"
            />
          </b-col>
        </b-row>

        <vue-good-table
          :columns="columns"
          :rows="rows"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
            mode: 'records',
          }"
          :total-rows="total"
          mode="remote"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span v-if="props.column.field === 'D_date'">
              {{ formatDate(props.row.D_date) }}
            </span>
            <span v-else-if="props.column.field === 'client'">
              {{ props.row.C_prenom }} {{ props.row.C_nom }}<br>
              <small class="text-muted">{{ props.row.C_email }}</small>
            </span>
            <span v-else-if="props.column.field === 'I_etat'">
              <b-badge :variant="etatVariant(props.row.I_etat)">
                {{ etatLabel(props.row.I_etat) }}
              </b-badge>
            </span>
            <span v-else-if="props.column.field === 'B_traite'">
              <b-badge :variant="props.row.B_traite ? 'success' : 'secondary'">
                {{ props.row.B_traite ? 'Oui' : 'Non' }}
              </b-badge>
            </span>
            <span v-else-if="props.column.field === 'B_archive'">
              <b-badge :variant="props.row.B_archive ? 'dark' : 'secondary'">
                {{ props.row.B_archive ? 'Oui' : 'Non' }}
              </b-badge>
            </span>
            <span v-else-if="props.column.field === 'actions'">
              <b-button
                size="sm"
                variant="primary"
                @click="voir(props.row.UI)"
              >
                Voir
              </b-button>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormSelect, BFormInput, BButton, BBadge, BContainer,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AdminNav from './AdminNav.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormSelect,
    BFormInput,
    BButton,
    BBadge,
    BContainer,
    VueGoodTable,
    AdminNav,
  },
  data() {
    return {
      admin: null,
      rows: [],
      total: 0,
      page: 1,
      pageLength: 25,
      searchDebounce: null,
      filters: {
        etat: -1,
        traite: -1,
        archive: -1,
        q: '',
      },
      optionsEtat: [
        { value: -1, text: 'Tous' },
        { value: 0, text: '0 — Créé' },
        { value: 1, text: '1 — Formule choisie' },
        { value: 2, text: '2 — Établissement' },
        { value: 3, text: '3 — Représentant' },
        { value: 4, text: '4 — Documents validés' },
        { value: 6, text: '6 — Payé' },
      ],
      optionsTraite: [
        { value: -1, text: 'Tous' },
        { value: 0, text: 'Non traités' },
        { value: 1, text: 'Traités' },
      ],
      optionsArchive: [
        { value: -1, text: 'Tous' },
        { value: 0, text: 'Non archivés' },
        { value: 1, text: 'Archivés' },
      ],
      columns: [
        { label: 'Date', field: 'D_date' },
        { label: 'Client', field: 'client' },
        { label: 'Raison sociale', field: 'C_raisonSociale' },
        { label: 'Formule', field: 'formule' },
        { label: 'État', field: 'I_etat' },
        { label: 'Traité', field: 'B_traite' },
        { label: 'Archivé', field: 'B_archive' },
        { label: 'Docs', field: 'nb_documents', type: 'number' },
        { label: 'Actions', field: 'actions', sortable: false },
      ],
    }
  },
  created() {
    const raw = localStorage.getItem('domAdminData')
    if (raw) this.admin = JSON.parse(raw)
    this.loadList()
  },
  methods: {
    authHeaders() {
      return { headers: { 'x-access-token': localStorage.getItem('domAdminToken') } }
    },
    loadList() {
      const params = {
        page: this.page,
        limit: this.pageLength,
        etat: this.filters.etat,
        traite: this.filters.traite,
        archive: this.filters.archive,
        q: this.filters.q,
      }
      this.$http.get('/admindom/dossiers', { params, ...this.authHeaders() })
        .then(response => {
          if (response.data.res === 1) {
            this.rows = response.data.dossiers
            this.total = response.data.total
          }
        })
        .catch(err => this.handleAuthError(err))
    },
    onSearch() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce)
      this.searchDebounce = setTimeout(() => {
        this.page = 1
        this.loadList()
      }, 350)
    },
    onPageChange(params) {
      this.page = params.currentPage
      this.loadList()
    },
    onPerPageChange(params) {
      this.pageLength = params.currentPerPage
      this.page = 1
      this.loadList()
    },
    voir(UI) {
      this.$router.push({ name: 'admin-dom-dossier-detail', params: { UIdemande: UI } })
    },
    logout() {
      localStorage.removeItem('domAdminToken')
      localStorage.removeItem('domAdminData')
      this.$router.push({ name: 'admin-dom-login' })
    },
    handleAuthError(err) {
      if (err && err.response && (err.response.status === 401 || err.response.status === 403)) {
        this.logout()
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Session expirée',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
      }
    },
    formatDate(d) {
      if (!d) return ''
      const dt = new Date(d)
      return `${dt.toLocaleDateString('fr-FR')} ${dt.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
    },
    etatLabel(etat) {
      const map = {
        0: 'Créé',
        1: 'Formule',
        2: 'Établissement',
        3: 'Représentant',
        4: 'Docs validés',
        5: 'Récap',
        6: 'Payé',
      }
      return map[etat] !== undefined ? map[etat] : etat
    },
    etatVariant(etat) {
      if (etat >= 6) return 'success'
      if (etat === 4) return 'info'
      if (etat >= 1) return 'primary'
      return 'secondary'
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';

.admin-dom-wrapper {
  min-height: 100vh;
  background-color: #f8f8f8;
  padding-bottom: 2rem;
}
</style>
